/** Unicode symbols as JS escapes � avoids encoding corruption in source files */
export const ARROW = '\u2192';
export const UP = '\u2191';
export const DOT = '\u00B7';
export const INFINITY = '\u221E';
export const EM_DASH = '\u2014';
export const EN_DASH = '\u2013';

/** Join with middle dot � safe for JSX text nodes */
export function dotJoin(...parts) {
  return parts.filter(Boolean).join(` ${DOT} `);
}
